// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid {
  text-align: center;
  display: grid;
  grid-template-columns: repeat(99, 20px);
  grid-template-rows: repeat(99, 20px);
}

.typography {
  background-color: white;
  font-size: small;
  padding-left: 5px;
  padding-right: 5px;
}

.mapContainer {
  height: 100%;
  width: 100%;
  scrollbar-gutter: stable both-edges;
  scrollbar-color: #9ea7b0 #f2f2f2;
}

.mapContainer::-webkit-scrollbar {
  height: 14px;
}

.mapContainer::-webkit-scrollbar-track {
  background: #f2f2f2;
}

.mapContainer::-webkit-scrollbar-thumb {
  background-color: #9ea7b0;
  border-radius: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/MapGrid/MapGrid.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,uCAAuC;EACvC,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB","sourcesContent":[".grid {\n  text-align: center;\n  display: grid;\n  grid-template-columns: repeat(99, 20px);\n  grid-template-rows: repeat(99, 20px);\n}\n\n.typography {\n  background-color: white;\n  font-size: small;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.mapContainer {\n  height: 100%;\n  width: 100%;\n  scrollbar-gutter: stable both-edges;\n  scrollbar-color: #9ea7b0 #f2f2f2;\n}\n\n.mapContainer::-webkit-scrollbar {\n  height: 14px;\n}\n\n.mapContainer::-webkit-scrollbar-track {\n  background: #f2f2f2;\n}\n\n.mapContainer::-webkit-scrollbar-thumb {\n  background-color: #9ea7b0;\n  border-radius: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
